var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_315",
    "data-name": "Group 315",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.686,
    height: 44.686,
    viewBox: "0 0 44.686 44.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 22.343,
    cy: 22.343,
    r: 22.343,
    fill: "rgba(255,255,255,0.07)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pc2-o-svgrepo-com",
    transform: "translate(9.967 9.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M0,0H24.752V24.752H0Z",
    fill: "rgba(0,0,0,0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M20.884,3a3.867,3.867,0,0,1,3.867,3.867v9.282a3.867,3.867,0,0,1-3.867,3.867H15.47v2.32h2.32a.773.773,0,1,1,0,1.547H6.961a.773.773,0,1,1,0-1.547h2.32v-2.32H3.867A3.868,3.868,0,0,1,0,16.317l0-.168V6.867A3.867,3.867,0,0,1,3.867,3ZM13.923,22.337v-2.32H10.829v2.32Zm6.961-17.79H3.867a2.32,2.32,0,0,0-2.32,2.32v9.282a2.32,2.32,0,0,0,2.32,2.32H20.884a2.32,2.32,0,0,0,2.32-2.32V6.867A2.32,2.32,0,0,0,20.884,4.547Z",
    transform: "translate(0 -0.68)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.55fed825d6a3b6082bfa031d58b7a659.svg";
export { ForwardRef as ReactComponent };